import React, { createContext, useContext, ReactNode } from 'react';

interface UserLocationContextType {
  userCountry?: string;
  isUSVisitor: boolean;
}

const UserLocationContext = createContext<{ userCountry?: string }>({});

interface UserLocationProviderProps {
  children: ReactNode;
  userCountry?: string;
}

export const UserLocationProvider: React.FC<UserLocationProviderProps> = ({
  children,
  userCountry,
}) => {
  const value = {
    userCountry,
  };

  return (
    <UserLocationContext.Provider value={value}>
      {children}
    </UserLocationContext.Provider>
  );
};

export const useUserLocation = (): UserLocationContextType => {
  const context = useContext(UserLocationContext);

  if (context === undefined) {
    throw new Error('useUserLocation must be used within a UserLocationProvider');
  }

  // Compute isUSVisitor based on userCountry
  const isUSVisitor = context.userCountry === 'US';

  return {
    userCountry: context.userCountry,
    isUSVisitor,
  };
};
